import {SubscriptionBooking} from './types'

export type SubscriptionPromoSummary = {
  code: string
  discountType: 'FIXED' | 'PERCENT'
  discount: number
  firstPaymentOnly: boolean
  // What the code took off the payments made so far.
  saved: number
  // The next unpaid cycle, with whether the code still applies to it.
  next: {price: number, startDate: number, discounted: boolean} | null
}

const round2 = (n: number) => Math.round(n * 100) / 100

/** The promo a pass was bought with, for the Billing tab; null for a pass bought without one. */
export const getSubscriptionPromoSummary = (
  booking: Pick<SubscriptionBooking, 'cycles' | 'promoApplied' | 'promoCode'> | null | undefined,
): SubscriptionPromoSummary | null => {
  if (!booking) {
    return null
  }
  const applied = booking.promoApplied
  const code = applied?.code || booking.promoCode
  if (!code) {
    return null
  }
  const cycles = booking.cycles
  const discountType = applied?.discountType || applied?.type || 'PERCENT'
  const discount = Number(applied?.discount ?? applied?.value ?? 0)
  const firstPaymentOnly = applied?.subscriptionDuration
    ? applied.subscriptionDuration === 'FIRST_PAYMENT'
    : applied?.appliesTo === 'firstPayment'
  const saved = round2(cycles.reduce((acc, cycle) => (
    cycle.isPaid && !cycle.credited ? acc + (Number(cycle.promoDiscount) || 0) : acc
  ), 0))
  const nextCycle = cycles.find((cycle) => !cycle.isPaid && Number(cycle.price) > 0)
  return {
    code,
    discountType,
    discount,
    firstPaymentOnly,
    saved,
    next: nextCycle
      ? {
        price: nextCycle.price,
        startDate: nextCycle.startDate,
        discounted: (Number(nextCycle.promoDiscount) || 0) > 0,
      }
      : null,
  }
}
